module.exports = __webpack_public_path__ + "static/media/slidingSub1.95fe0c69.png";